module.exports = __webpack_public_path__ + "static/global-0d009c3b606e8a35366030a0c0e33fb8.png";